import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from './components/navbar/navbar.component';
import { RouterModule } from '@angular/router';
import { SharedUiIconsModule } from '@shared/ui/icons';
import { NavbarItemComponent } from './components/navbar-item/navbar-item.component';
import { NavbarHeaderComponent } from './components/navbar-header/navbar-header.component';
import { SharedUiButtonsModule } from '@shared/ui/buttons';
import { SharedUtilsPipesModule } from '@shared/utils/pipes';
import { SharedUtilsDisableImageCachingModule } from '@shared/utils/disable-image-caching';
import { HorizontalNavbarComponent } from './components/horizontal-navbar/horizontal-navbar.component';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { MenubarModule } from 'primeng/menubar';
import { SharedUiProfilePictureModule } from '@shared/ui/profile-picture';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SharedUiIconsModule,
    SharedUiButtonsModule,
    SharedUtilsPipesModule,
    SharedUtilsDisableImageCachingModule,
    NgbDropdownModule,
    MenubarModule,
    SharedUiProfilePictureModule,
  ],
  declarations: [NavbarComponent, NavbarItemComponent, NavbarHeaderComponent, HorizontalNavbarComponent],
  exports: [NavbarComponent, NavbarHeaderComponent, HorizontalNavbarComponent],
})
export class SharedUiNavbarsModule {}
